import create from "zustand"

export const useStore = create((set) => ({
  flightSignUpModalOpen: false,
  setFlightSignUpModalOpen: (value) => set({ flightSignUpModalOpen: value }),

  parkingFlightSignUpModalOpen: false,
  setParkingFlightSignUpModalOpen: (value) => set({ parkingFlightSignUpModalOpen: value }),
}))
